module.exports = __webpack_public_path__ + "static/img/box.237616d5.png";